import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/privacy/page.js");
